import { Box, HStack } from "@chakra-ui/react";
import React from "react";
import PatientProfileInlineEditableRow from "../../../../../../../entityProfileModal/components/EntityProfileInlineEditableRow";
import type { SummaryEditableField } from "../../../PatientProfileSummarySection.hooks";
import EntityModalButton from "../../../../../../../entityProfileModal/components/EntityModalButton";

export function SummaryEditableRow(props: {
  activeField: SummaryEditableField | null;
  children: React.ReactNode;
  cancelOnBlur?: boolean;
  field: SummaryEditableField;
  label: string;
  value: React.ReactNode;
  onActivate: (field: SummaryEditableField) => void;
  onCancel: () => void;
  onCommit: () => void;
}) {
  return (
    <PatientProfileInlineEditableRow
      activeField={props.activeField}
      cancelOnBlur={props.cancelOnBlur}
      field={props.field}
      label={props.label}
      value={props.value}
      onActivate={props.onActivate}
      onCancel={props.onCancel}
      onCommit={props.onCommit}
    >
      {props.children}
    </PatientProfileInlineEditableRow>
  );
}

export function SummaryAddressActionRow(props: {
  children?: React.ReactNode;
  onCustomizeAddress: () => void;
}) {
  return (
    <HStack justifyContent="space-between" minH="42px" py={1.5} spacing={4}>
      <EntityModalButton
        iconClassName="fa fa-pencil"
        kind="blue"
        size="sm"
        style={{ flexShrink: 0 }}
        variant="outline"
        onClick={props.onCustomizeAddress}
      >
        Customize address
      </EntityModalButton>
      {props.children === undefined ? null : (
        <Box flex="1 1 auto" maxW="520px" minW="280px">
          {props.children}
        </Box>
      )}
    </HStack>
  );
}
